import { useState } from 'react'
import { Grid } from '@material-ui/core'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Button from '@material-ui/core/Button'
import VFacturas from '../VFacturas'
import VFacturasHistorial from '../VFacturasHistorial'
const VToggleFacturas = () => {
    const [toggle, setToggle] = useState(true)
    const onClick = () => {
        setToggle(!toggle)
    }
    return (
        <div style={{ marginTop: "2rem" }}>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "10px" }}>
                        <ButtonGroup disableElevation variant="contained" color="primary">
                            <Button onClick={onClick} color={toggle ? 'secondary' : 'default'} >Recientes</Button>
                            <Button onClick={onClick} color={!toggle ? 'secondary' : 'default'} >Aprobadas</Button>
                        </ButtonGroup>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {
                        (toggle) &&
                        <VFacturas />
                    }
                    {
                        (!toggle) &&
                        <VFacturasHistorial />
                    }
                </Grid>
            </Grid>
        </div>
    )
}
export default VToggleFacturas